import React, { useEffect } from "react";
import {
  Avatar,
  Box,
  Button,
  Grid,
  List,
  ListItem,
  MenuItem,
  Paper,
  Select,
  Stack,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import styles from "../../../styles/pages/user/qcagentdashboard/qc-account.module.scss";
import EditIcon from "../../../ui/Icons/EditIcon";
import { Link } from "react-router-dom";
import userImage from "../../../public/assets/images/user_upload_img.png";
import { useRef } from "react";
import { useState } from "react";
import AlertIcon from "../../../ui/Icons/Alert";
import ManagerDashboardWapper from "../../../layout/wrapper/ManagerDashboardWapper";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import QcDashboardWrapper from "../../../layout/wrapper/QcDashboradWrapper";
import { useMutation, useQuery } from "react-query";
import {
  getQcProfileDetails,
  updateQcProfileDetails,
} from "../../../api/functions/qc.api";
import * as yup from "yup";
import validationText from "../../../json/messages/validationText";
import { isStringRegExp, phoneRegExp } from "../../../config/regExp";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

const SelectItem = [
  {
    name: "Select country",
  },
  {
    name: "Option1",
  },
  {
    name: "Option2",
  },
];

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
import countries from "countries-list";
import {
  getAbsoluteImageURI,
  truncateString,
} from "../../../lib/functions/utils.lib";
import useNotiStack from "../../../hooks/useNotistack";
import TabBackIcon from "../../../ui/Icons/TabBackIcon";
import TabSaveIcon from "../../../ui/Icons/TabSaveIcon";
// import NOprofileImage from "../../../public/assets/images/no-image.svg";
import NOprofileImage from "../../../public/assets/images/no-image.svg";
import { parseCookies } from "nookies";
import ChnagePassword from "../CopywriterDashboard/Components/ChnagePassword";
import { useAppSelector } from "../../../hooks/useAppSelector";
import { setLoginData } from "../../../redux-toolkit/slices/userSlice";
import { useAppDispatch } from "../../../hooks/useAppDispatch";

const schema = yup.object().shape({
  name: yup
    .string()
    .nullable()
    .matches(isStringRegExp, "Invalid Name")
    .trim()
    .required(validationText.error.username)
    .label("First Name")
    .max(256),

  last_name: yup
    .string()
    .nullable()
    .matches(isStringRegExp, "Invalid Lastname")
    .trim()
    .required(validationText.error.last_name)
    .label("Last Name")
    .max(256),

  address: yup
    .string()
    .nullable()
    .max(32)
    .required(validationText.error.address),
  city: yup.string().nullable().max(32).required(validationText.error.city),

  zip_code: yup
    .string()
    .nullable()
    .max(7)
    .required(validationText.error.zip_code),

  phone: yup
    .string()
    .nullable()
    .required()
    .matches(phoneRegExp, "Phone number is not valid")
    .label("Phone number")
    .min(8, "Phone number must be at least 8 characters")
    .max(15, "Phone number must be at most 15 characters"),

  state: yup.string().nullable().max(32).required(validationText.error.state),
});

export default function MyAccount() {
  const [value, setValue] = React.useState(0);
  const [editFullName, setEditFullName] = useState(false);
  const [editPhysicalAddress, setEditPhysicalAddress] = useState(false);
  const [editPhoneNumber, setEditPhoneNumber] = useState(false);
  const { toastSuccess, toastError } = useNotiStack();

  // const { data: QcData, refetch: refetchUserDetails } = useQuery(
  //   ["getQcProfile"],
  //   async () => getQcProfileDetails(),
  //   {
  //     onSuccess: (res) => {
  //       setprofileimg(res.avatar);
  //     },
  //   }
  // );
  const { userData: QcData } = useAppSelector((s) => s.userSlice);
  // console.warn("userData head", QcData);
  const [profileimg, setprofileimg] = useState();
  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const resetProfileUpdateForm = () => {
    if (QcData) {
      const {
        name,
        last_name,
        address,
        city,
        zip_code,
        phone,
        state,
        country,
        avatar,
      } = QcData;
      setCountry(country);
      reset({ name, last_name, address, city, zip_code, phone, state });
      setprofileimg(avatar);
    }
  };
  // console.warn("QcData", QcData);

  const [profileImage, setProfileImage] = useState(null);
  const [imageCheck, setImageCheck] = useState(false);
  const [inputKey, setInputKey] = useState(0);
  // console.warn("profileimg", profileimg);

  function handleProfileImage1(e) {
    if (
      e.target.files[0]?.type === "image/jpeg" ||
      e.target.files[0]?.type === "image/png" ||
      e.target.files[0]?.type === "image/jpg"
    ) {
      if (e.target.files[0]?.size <= 10000000) {
        setProfileImage(e.target.files[0]);
        setImageCheck(true);
      } else {
        toastError("Please upload image of proper size.");
      }
    } else {
      toastError("Please upload image of proper format.");
    }
  }

  const handleCancel = () => {
    // alert("hi")
    setProfileImage(null);
    setImageCheck(false);
    setInputKey((prevKey) => prevKey + 1);
  };

  const openFullNameEditor = () => {
    setEditFullName(true);
  };

  const closeFullNameEditor = () => {
    setEditFullName(false);
    resetProfileUpdateForm();
  };

  const openPhysicalAddressEditor = () => {
    setEditPhysicalAddress(true);
  };

  const closePhysicalAddressEditor = () => {
    setEditPhysicalAddress(false);
    resetProfileUpdateForm();
  };

  const openPhoneNumberEditor = () => {
    setEditPhoneNumber(true);
  };

  const closePhoneNumberEditor = () => {
    setEditPhoneNumber(false);
    resetProfileUpdateForm();
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [age, setAge] = React.useState("0");
  const handleChange2 = (event) => {
    setAge(event.target.value);
  };

  const fileInput = useRef(null);

  const handleClick = () => {
    fileInput.current.children[0].children[0].click();
  };

  const [file, setFile] = useState(userImage);

  const fileChange = (e) => {
    // console.warn(e.target.files);
    setFile(URL.createObjectURL(e.target.files[0]));
  };
  const handleChanges = (e) => {
    setFile(userImage);
  };

  const [country, setCountry] = useState();

  const handleChangeCountry = (e) => {
    // console.warn("compare", e.target.value, e.target.value == "Senegal");
    setCountry(e.target.value);
  };

  useEffect(() => {
    resetProfileUpdateForm();
  }, [QcData, reset]);

  const dispatch = useAppDispatch();

  const { mutate } = useMutation({
    mutationFn: updateQcProfileDetails,
    onSuccess: (res) => {
      // console.warn("upddate res", res);
      dispatch(setLoginData(res.user));
      toastSuccess("User updated successfully");
      closeFullNameEditor();
      closePhysicalAddressEditor();
      closePhoneNumberEditor();
      setImageCheck(false);
      // refetchUserDetails();
    },
  });

  const submitProfileForm = (data) => {
    // console.warn("cl");
    // console.warn("data", data);

    const formData = new FormData();
    if (profileImage !== null) {
      formData.append("avatar", profileImage);
    }

    const formFields = {
      name: data?.name,
      last_name: data?.last_name,
      user_id: QcData?.id,
      email: QcData?.email,
      address: data?.address,
      city: data?.city,
      zip_code: data?.zip_code,
      phone: data?.phone,
      state: data?.state,
      country: country,
    };

    Object.entries(formFields).map(([key, value]) => {
      if (value) {
        formData.append(key, value);
      }
    });
    mutate(formData);
  };

  // console.warn("errors", errors);
  // console.warn("QcData", QcData);

  const countryNames = Object.values(countries.countries).map(
    (country) => country.name
  );
  const cookies = parseCookies();
  const userData = JSON.parse(cookies?.userdetails || "{}");

  const removeprofileImage = () => {
    setProfileImage(null);
    setprofileimg(null);
    setImageCheck(true);
    setInputKey((prevKey) => prevKey + 1);
    const formData = new FormData();
    formData.append("remove_avatar", true);
    formData.append("user_id", userData?.id);
    mutate(formData);
    // mutate(formData).then((response) => {
    //   if (response.message === "User updated successfully") {
    //     toastSuccess("User updated successfully");
    //     // router.reload();
    //     CopywritersRefetch();
    //     queryClient.invalidateQueries(["Copywriters"]);
    //   }
    // });
  };

  //   console.warn("country", country == "Senegal");

  return (
    <>
      <QcDashboardWrapper>
        <Paper elevation={0} className={styles.pageManager}>
          <Box className={styles.accountsecrp_outer}>
            <Box className={styles.accountsecrp_top}>
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
              >
                <Tab label="Personal Details" {...a11yProps(0)} />
                <Tab label="Account Settings" {...a11yProps(1)} />
              </Tabs>
            </Box>

            <Box className={styles.accountsecrp_btms}>
              <PerfectScrollbar className={styles.managerMyacntScrol}>
                <CustomTabPanel value={value} index={0}>
                  <Box className={styles.personalDetailsTab}>
                    <Box className={styles.accountsecrp_btms_inputwrp}>
                      <Box className={styles.heaing_info_label}>
                        <Typography variant="caption">Full name</Typography>
                        {/* <Button
                          onClick={handleSubmit(submitProfileForm)}
                          //   onClick={() => console.warn("click")}
                          className={styles.wdit_spn}
                        >
                          {" "}
                          <EditIcon />{" "}
                        </Button> */}
                        {!editFullName ? (
                          <Button onClick={openFullNameEditor}>
                            <EditIcon />
                          </Button>
                        ) : (
                          <Box className={styles.editSaveBtn}>
                            <Button onClick={closeFullNameEditor}>
                              <TabBackIcon />
                            </Button>
                            <Button onClick={handleSubmit(submitProfileForm)}>
                              <TabSaveIcon />
                            </Button>
                          </Box>
                        )}
                      </Box>
                      <Box className={styles.formGroupLeft}>
                        <Stack
                          direction={"row"}
                          alignItems={"center"}
                          flexWrap={"wrap"}
                          className={styles.inputlabel_wrapper_details}
                        >
                          <Box
                            className={`${styles.firstName} ${styles.groupCol}`}
                          >
                            <Box className={styles.namedetails_input}>
                              <Typography
                                variant="h6"
                                className={styles.heading_label}
                              >
                                First Name
                              </Typography>
                              <TextField
                                placeholder="First Name"
                                {...register("name")}
                                disabled={!editFullName}
                              />
                              {errors.name && (
                                <p
                                  style={{
                                    color: "red",
                                    textAlign: "left",
                                    fontSize: "15px",
                                  }}
                                >
                                  {errors.name.message}
                                </p>
                              )}
                            </Box>
                          </Box>
                          <Box
                            className={`${styles.lastName} ${styles.groupCol}`}
                          >
                            <Box className={styles.namedetails_input}>
                              <Typography
                                variant="h6"
                                className={styles.heading_label}
                              >
                                Last name
                              </Typography>
                              <TextField
                                placeholder=""
                                {...register("last_name")}
                                disabled={!editFullName}
                              />
                              {errors.last_name && (
                                <p
                                  style={{
                                    color: "red",
                                    textAlign: "left",
                                    fontSize: "15px",
                                  }}
                                >
                                  {errors.last_name.message}
                                </p>
                              )}
                            </Box>
                          </Box>
                        </Stack>
                      </Box>
                    </Box>
                    <Box className={styles.accountsecrp_btms_inputwrp}>
                      <Box className={styles.heaing_info_label}>
                        <Typography variant="h4">Physical Address</Typography>
                        {!editPhysicalAddress ? (
                          <Button onClick={openPhysicalAddressEditor}>
                            <EditIcon />
                          </Button>
                        ) : (
                          <Box className={styles.editSaveBtn}>
                            <Button onClick={closePhysicalAddressEditor}>
                              <TabBackIcon />
                            </Button>
                            <Button onClick={handleSubmit(submitProfileForm)}>
                              <TabSaveIcon />
                            </Button>
                          </Box>
                        )}
                      </Box>
                      <Box className={styles.formGroupLeft}>
                        <Stack
                          direction={"row"}
                          alignItems={"center"}
                          flexWrap={"wrap"}
                          className={styles.inputlabel_wrapper_details}
                        >
                          <Box
                            className={`${styles.address} ${styles.groupCol}`}
                          >
                            <Box className={styles.namedetails_input}>
                              <Typography
                                variant="h6"
                                className={styles.heading_label}
                              >
                                Address
                              </Typography>
                              <TextField
                                {...register("address")}
                                disabled={!editPhysicalAddress}
                              />
                              {errors.address && (
                                <p
                                  style={{
                                    color: "red",
                                    textAlign: "left",
                                    fontSize: "15px",
                                  }}
                                >
                                  {errors.address.message}
                                </p>
                              )}
                            </Box>
                          </Box>
                          <Box className={`${styles.city} ${styles.groupCol}`}>
                            <Box className={styles.namedetails_input}>
                              <Typography
                                variant="h6"
                                className={styles.heading_label}
                              >
                                City
                              </Typography>
                              <TextField
                                {...register("city")}
                                disabled={!editPhysicalAddress}
                              />
                              {errors.city && (
                                <p
                                  style={{
                                    color: "red",
                                    textAlign: "left",
                                    fontSize: "15px",
                                  }}
                                >
                                  {errors.city.message}
                                </p>
                              )}
                            </Box>
                          </Box>
                          <Box className={`${styles.state} ${styles.groupCol}`}>
                            <Box className={styles.namedetails_input}>
                              <Typography
                                variant="h6"
                                className={styles.heading_label}
                              >
                                State
                              </Typography>
                              <TextField
                                {...register("state")}
                                disabled={!editPhysicalAddress}
                              />
                            </Box>
                            {errors.state && (
                              <p
                                style={{
                                  color: "red",
                                  textAlign: "left",
                                  fontSize: "15px",
                                }}
                              >
                                {errors.state.message}
                              </p>
                            )}
                          </Box>
                          <Box className={`${styles.zip} ${styles.groupCol}`}>
                            <Box className={styles.namedetails_input}>
                              <Typography
                                variant="h6"
                                className={styles.heading_label}
                              >
                                Zip Code
                              </Typography>
                              <TextField
                                {...register("zip_code")}
                                disabled={!editPhysicalAddress}
                              />
                              {errors.zip_code && (
                                <p
                                  style={{
                                    color: "red",
                                    textAlign: "left",
                                    fontSize: "15px",
                                  }}
                                >
                                  {errors.zip_code.message}
                                </p>
                              )}
                            </Box>
                          </Box>
                          <Box
                            className={`${styles.country} ${styles.groupCol}`}
                          >
                            <Box className={styles.namedetails_input}>
                              <Typography
                                variant="h6"
                                className={styles.heading_label}
                              >
                                Country
                              </Typography>
                              {country && (
                                <Box
                                  className={styles.namedetails_input_select}
                                >
                                  <Select
                                    onChange={handleChangeCountry}
                                    value={country}
                                    disabled={!editPhysicalAddress}
                                  >
                                    {countryNames.map((item, index) => (
                                      <MenuItem key={index} value={item}>
                                        {truncateString(item, 20)}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </Box>
                              )}
                            </Box>
                          </Box>
                        </Stack>
                      </Box>
                    </Box>
                    <Box className={styles.accountsecrp_btms_inputwrp}>
                      <Box className={styles.heaing_info_label}>
                        <Typography variant="h4">Phone Number</Typography>
                        {/* <Button className={styles.wdit_spn}>
                          {" "}
                          <EditIcon />{" "}
                        </Button> */}
                        {!editPhoneNumber ? (
                          <Button onClick={openPhoneNumberEditor}>
                            <EditIcon />
                          </Button>
                        ) : (
                          <Box className={styles.editSaveBtn}>
                            <Button onClick={closePhoneNumberEditor}>
                              <TabBackIcon />
                            </Button>
                            <Button onClick={handleSubmit(submitProfileForm)}>
                              <TabSaveIcon />
                            </Button>
                          </Box>
                        )}
                      </Box>
                      <Box className={styles.formGroupLeft}>
                        <Stack
                          direction={"row"}
                          alignItems={"center"}
                          flexWrap={"wrap"}
                          className={styles.inputlabel_wrapper_details}
                        >
                          <Box
                            className={`${styles.phoneNo} ${styles.groupCol}`}
                          >
                            <Box className={styles.namedetails_input}>
                              <TextField
                                {...register("phone")}
                                disabled={!editPhoneNumber}
                              />
                            </Box>
                            {errors.phone && (
                              <p
                                style={{
                                  color: "red",
                                  textAlign: "left",
                                  fontSize: "15px",
                                }}
                              >
                                {errors.phone.message}
                              </p>
                            )}
                          </Box>
                        </Stack>
                      </Box>
                    </Box>
                  </Box>
                </CustomTabPanel>
                <CustomTabPanel value={value} index={1}>
                  {/* <Box className={styles.profile_pic_upload_sec}>
                    <Typography
                      variant="h4"
                      className={styles.profile_upload_head}
                    >
                      Profile Picture
                    </Typography>
                    <Box className={styles.gap_wrapper_emltb}>
                      <Box className={styles.upload_profile_pic_parent}>
                        <Box className={styles.file_upload_prof_lf}>
                          <img src={file} alt="" />
                        </Box>

                        <Box className={styles.file_upload_prof_rght}>
                          <Box className={styles.file_uploader_btns}>
                            <Box className={styles.file_uploader_picture}>
                              <Box className={styles.file_uploader_picture_in}>
                                <Button onClick={() => handleClick()}>
                                  Update Picture
                                </Button>
                                <TextField
                                  type="file"
                                  ref={fileInput}
                                  onChange={fileChange}
                                />
                              </Box>
                            </Box>

                            <Box className={styles.file_remover}>
                              <Box className={styles.file_remover_in}>
                                <Button onClick={handleChanges}>
                                  Remove It
                                </Button>
                              </Box>
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  </Box> */}
                  <Box className={styles.profile_pic_upload_sec}>
                    <Typography
                      variant="h4"
                      className={styles.profile_upload_head}
                    >
                      Profile Picture
                    </Typography>
                    <Stack
                      direction="row"
                      alignItems="center"
                      flexWrap="wrap"
                      className={styles.profileSec}
                    >
                      {profileImage !== null ? (
                        <>
                          {/* <img
                        src={URL.createObjectURL(profileImage)}
                        width={100}
                        height={100}
                        alt={""}
                      /> */}

                          <Avatar
                            alt="Profile Image"
                            src={URL.createObjectURL(profileImage)}
                            sx={{ width: 97, height: 97 }}
                          />
                        </>
                      ) : (
                        <>
                          {profileimg === null ? (
                            <Avatar
                              alt="piral Snare"
                              src={NOprofileImage}
                              sx={{ width: 97, height: 97 }}
                            />
                          ) : (
                            <Avatar
                              alt="Profile Image"
                              src={
                                profileimg == "users/default.png"
                                  ? NOprofileImage
                                  : getAbsoluteImageURI(profileimg)
                              }
                              sx={{ width: 97, height: 97 }}
                            />
                          )}
                        </>
                      )}
                      {/* <Avatar
                        src={NOprofileImage}
                        sx={{ width: 97, height: 97 }}
                      /> */}

                      <List>
                        <ListItem
                          className={styles.customUploadFile}
                          style={{ cursor: "pointer" }}
                        >
                          <input
                            key={inputKey}
                            type="file"
                            id="upload"
                            hidden
                            onChange={handleProfileImage1}
                            accept="image/*"
                          />
                          {profileImage !== null && imageCheck ? (
                            <>
                              <label
                                htmlFor="update"
                                onClick={handleSubmit(submitProfileForm)}
                              >
                                save
                              </label>
                            </>
                          ) : (
                            <>
                              {profileimg === "users/default.png" ? (
                                <label htmlFor="upload">Upload picture</label>
                              ) : (
                                <label htmlFor="upload">change picture</label>
                              )}
                            </>
                          )}
                        </ListItem>
                        {profileimg !== "users/default.png" ||
                        profileImage !== null ? (
                          <>
                            {profileImage !== null && imageCheck ? (
                              <ListItem style={{ cursor: "pointer" }}>
                                <Button
                                  className={styles.removeBtn}
                                  onClick={handleCancel}
                                >
                                  cancel
                                </Button>
                              </ListItem>
                            ) : (
                              <ListItem style={{ cursor: "pointer" }}>
                                <Button
                                  className={styles.removeBtn}
                                  onClick={() => {
                                    removeprofileImage();
                                    handleSubmit(submitProfileForm);
                                  }}
                                >
                                  remove it
                                </Button>
                              </ListItem>
                            )}
                          </>
                        ) : (
                          ""
                        )}
                      </List>
                    </Stack>
                  </Box>
                  <Box className={styles.email_details_inputsec}>
                    <Box className={styles.email_details_inputsec_inner}>
                      <Typography
                        variant="h4"
                        className={`${styles.profile_upload_head} ${styles.neww}`}
                      >
                        Email Address
                      </Typography>
                      <Box className={styles.gap_wrapper_emltb}>
                        <Box className={styles.add_user_address}>
                          <Typography variant="body1">
                            Your email address is{" "}
                            <Link to="mailto:username@viralsnare.com">
                              {QcData?.email}
                            </Link>
                          </Typography>
                        </Box>
                        <Box className={styles.add_user_emailchn}>
                          <Typography variant="caption">
                            <i>
                              <AlertIcon />
                            </i>
                            Email address cannot be changed.
                          </Typography>
                        </Box>
                      </Box>
                    </Box>

                    {/* <Box
                      className={`${styles.email_details_inputsec_inner} ${styles.password_details_inputsec_inner}`}
                    >
                      <Typography
                        variant="h4"
                        className={`${styles.profile_upload_head} ${styles.neww}`}
                      >
                        Password
                      </Typography>
                      <Box className={styles.gap_wrapper_emltb}>
                        <Grid
                          container
                          rowSpacing={3.3}
                          columnSpacing={{ xs: 1, sm: 2, md: 5.5 }}
                        >
                          <Grid item xs={12}>
                            <Grid
                              container
                              rowSpacing={2.75}
                              columnSpacing={{ xs: 1, sm: 2, md: 5.5 }}
                            >
                              <Grid item lg={3.98} xs={12}>
                                <Box className={styles.namedetails_input}>
                                  <Typography
                                    variant="h6"
                                    className={`${styles.heading_label} ${styles.newl_label}`}
                                  >
                                    Current password
                                  </Typography>
                                  <TextField type="password" />
                                </Box>
                              </Grid>
                            </Grid>
                          </Grid>

                          <Grid item xs={12}>
                            <Grid
                              container
                              rowSpacing={2.75}
                              columnSpacing={{ xs: 1, sm: 2, md: 5.9 }}
                            >
                              <Grid item lg={3.98} xs={12}>
                                <Box className={styles.namedetails_input}>
                                  <Typography
                                    variant="h6"
                                    className={`${styles.heading_label} ${styles.newl_label}`}
                                  >
                                    New password
                                  </Typography>
                                  <TextField type="password" />
                                </Box>
                              </Grid>

                              <Grid item lg={3.98} xs={12}>
                                <Box className={styles.namedetails_input}>
                                  <Typography
                                    variant="h6"
                                    className={`${styles.heading_label} ${styles.newl_label}`}
                                  >
                                    Confirm new password
                                  </Typography>
                                  <TextField type="password" />
                                </Box>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Box>
                      <Box className={styles.submit_password_sec}>
                        <Button>Save Password</Button>
                      </Box>
                    </Box> */}
                    <ChnagePassword />
                  </Box>
                </CustomTabPanel>
              </PerfectScrollbar>
            </Box>
          </Box>
        </Paper>
      </QcDashboardWrapper>
    </>
  );
}
